import { SchedulesStatusFilterProps } from "../../../interfaces/props/SaudeOnline/SchedulesStatusFilterProps";
import FilterSelect from "../../../components/FilterSelect";

const SchedulesStatusFilter: React.FC<SchedulesStatusFilterProps> = ({
  onStatusChange,
}) => {

  const handleChange = (opcao: string) => {
    onStatusChange(opcao);
  };

  const options = [
    { id: "todos", descricao: "Todos" }, 
    { id: "agendado", descricao: "Agendados" },
    { id: "cancelado", descricao: "Cancelados" },
    { id: "concluido", descricao: "Concluídos" },
    { id: "confirmado", descricao: "Confirmados pela clínica" },
    { id: "faltou", descricao: "Ausente" },
  ]

  return (
    <div className="schedules-status-filter">
      <FilterSelect 
        title={"Filtrar status"} 
        options={options} 
        disabled={false} 
        handleChange={handleChange} />
      
    </div>
  );
};

export default SchedulesStatusFilter;
